
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12997',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12997",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9862",
  "foundations-components": "static-1.8314",
  "foundations-components-legacy": "static-1.1339",
  "foundations-theming": "static-1.4649",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8229",
  "hub-http-shared-msw-handlers": "static-1.10450",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11679",
  "I18n": "static-7.1650",
  "jasmine-runner": "static-1.6660",
  "marketplace-discovery-studio-lib": "static-1.461",
  "marketplace-storefront-base": "static-1.13060",
  "quartz": "static-1.7303",
  "react-dlb": "static-1.83",
  "react-rhumb": "static-1.16910",
  "reactive-variable-buffer-atom": "static-1.3061",
  "reporting-testing-lib": "static-1.10306",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12725",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7491",
  "ui-addon-i18n": "static-1.11352",
  "ui-addon-react-router-dom": "static-1.9739",
  "unified-auth": "static-1.738",
  "unified-auth-core-lib": "static-1.1020",
  "usage-tracker": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.6",
  "customer-data-property-utils": "static-1.8301",
  "hub-http": "static-1.6422",
  "integrations-lib": "static-1.16793",
  "marketplace-ui-common": "static-1.20421",
  "marketplace-ui-install": "static-1.407",
  "property-management-iframe": "static-1.13833",
  "quartz-config": "static-1.1081",
  "quartz-core": "static-1.6522",
  "quartz-routing": "static-1.733",
  "quick-fetch": "static-1.4060",
  "react": "static-7.189",
  "rpc-client-utils": "static-1.4864",
  "ts-schema": "static-1.4223",
  "ui-universal-auth": "static-1.9224",
  "UIComponents": "static-3.8625",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3542",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3580",
  "quartz-webpack": "static-1.3527",
  "bend-plugin-quartz-routing": "static-1.381",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4583",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5081",
  "foundations-theming-specialty": "static-1.2365",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9631",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.50",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5484",
  "react-virtualized": "static-2.102",
  "StyleGuideUI": "static-3.491",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2346",
  "ui-fonts": "static-1.941",
  "ui-images": "static-2.1213",
  "bend-plugin-foundations-theming": "static-1.3132",
  "foundations-theming-base": "static-1.3634",
  "stylex": "static-1.37",
  "HeadJS": "static-2.781",
  "hs-test-utils-bend-plugin": "static-1.3340",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4529",
  "ui-addon-video-player": "static-1.8912",
  "ai-components-ui-library": "static-1.9468",
  "ai-rendering-library": "static-1.10892",
  "chirp-fetch": "static-1.2093",
  "connections-embed-lib": "static-1.1361",
  "copilot-toolkit": "static-1.11654",
  "feedback-loader": "static-1.29667",
  "laboratory-lib": "static-3.7357",
  "marketplace-embed": "static-1.22700",
  "marketplace-ui-details": "static-1.10316",
  "marketplace-ui-reviews": "static-1.20376",
  "marketplace-ui-tracking": "static-1.14591",
  "sanitize-text": "static-1.8351",
  "usage-tracker-multi": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.6",
  "wootric-nps": "static-1.7125",
  "quartz-head": "static-1.968",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4859",
  "immer": "static-1.33",
  "immerable": "static-1.4353",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2629",
  "reporting-data": "static-1.68373",
  "cssUtils": "static-1.852",
  "flux-actions": "static-1.355",
  "HubStyle": "static-2.11986",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10414",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10571",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.6",
  "icons": "static-2.668",
  "marketplace-ui-apps-core": "static-1.18953",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4713",
  "foundations-components-test-utils": "static-1.5797",
  "quartz-i18n": "static-1.978",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.255",
  "ads-unified-auth-lib": "static-1.778",
  "google-sheets-integration-lib": "static-1.832",
  "microsoft-drive-integration-lib": "static-1.942",
  "surveymonkey-integration-lib": "static-1.276",
  "slack-ui-library": "static-1.10605",
  "fsm": "static-1.3937",
  "customer-data-objects": "static-1.7887",
  "property-translator": "static-1.5600",
  "hs-locale-management": "static-1.223",
  "frontend-preferences-client": "static-1.8132",
  "hs-promise-utils": "static-1.5799",
  "hubspot-apollo-client": "static-1.5083",
  "integrations-error-boundary-lib": "static-1.14208",
  "integrations-tracking-lib": "static-1.5813",
  "native-integrations-shared-strings": "static-1.7983",
  "sanitize": "static-1.4683",
  "superstore": "static-1.4964",
  "ui-shepherd-react": "static-3.10467",
  "ai-settings-ui-library": "static-1.8195",
  "hub-http-janus": "static-1.858",
  "hubspotter-http": "static-1.4793",
  "immutable-less": "static-1.4856",
  "marketplace-ui-client-types": "static-1.17828",
  "nav-meta": "static-1.30239",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18265",
  "ui-product-approvals-common": "static-1.789",
  "ai-studio-lib": "static-1.12236",
  "hubspot-prosemirror": "static-1.18808",
  "integrations-reconnect-lib": "static-1.334",
  "ui-addon-iframeable": "static-1.9280",
  "ui-addon-integrations-directory-panel": "static-2.8228",
  "ui-product-approvals": "static-1.28894",
  "ui-tool-access": "static-1.10358",
  "inbound-db-properties-service-client": "static-1.3987",
  "property-management-common": "static-1.6121",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.978",
  "quartz-test": "static-1.978",
  "quartz-tracking": "static-1.682",
  "trellis-components": "static-1.2365",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.274",
  "bender-build-tools": "static-1.3323",
  "usage-tracker-anonymous": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-public": "static-1-session-replay-endpoint-migration.6",
  "amplitude-session-replay-browser": "static-1.60",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22350",
  "ContentUtils": "static-1.68952",
  "customer-data-objects-ui-components": "static-1.13237",
  "sassPrefix": "static-1.160",
  "avatar-components": "static-1.2702",
  "breeze-engine-core": "static-1.709",
  "breeze-onboarding-components": "static-1.516",
  "customer-data-filters-ui": "static-1.40575",
  "customer-data-reference-ui-components": "static-1.13382",
  "embedded-academy-lib": "static-1.15108",
  "ExportDialog": "static-6.10584",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41813",
  "reporting-snowflake": "static-1.56991",
  "reporting-ui-components": "static-2.65644",
  "reporting-visualizations": "static-1.60449",
  "trellis-theming": "static-1.1158",
  "ui-addon-teams": "static-1.21807",
  "upgrade-components-lib": "static-1.406",
  "magpie-lib": "static-1.5697",
  "navigation-components": "static-1.18602",
  "breeze-engine-lib": "static-1.1431",
  "magpie-types": "static-1.5157",
  "simple-logging-lib": "static-1.3255",
  "fail-safe": "static-1.152",
  "app-governance-lib": "static-1.2172",
  "developer-experience-shared-components": "static-1.10707",
  "purchase-motions-components": "static-1.6219",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9837",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3907",
  "reference-resolvers": "static-1.8381",
  "ui-extensibility-client-types": "static-1.4128",
  "hubspot-apollo-cache": "static-1.542",
  "universal-page-editor-lib": "static-1.3216",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3348",
  "atom": "static-1.5281",
  "merchandise-lib": "static-1.269",
  "salesImages": "static-1.529",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10846",
  "ui-addon-draggable": "static-3.4960",
  "content-assistance-lib": "static-1.8064",
  "content-media-capture": "static-1.5168",
  "customer-data-ui-utilities": "static-1.10030",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24225",
  "growth-payments-core": "static-1.25969",
  "knowledge-content-types": "static-1.8597",
  "payment-link-components": "static-1.23982",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20176",
  "ui-addon-emoji-picker": "static-1.10091",
  "ui-business-units-lib": "static-1.9286",
  "video-components-external": "static-1.11928",
  "video-data-lib": "static-1.35586",
  "navigation-messaging": "static-1.7929",
  "react-dnd-compat": "static-1.4820",
  "batch-promise": "static-1.1750",
  "crm-component-utils": "static-1.39633",
  "crm-properties-common-lib": "static-1.6093",
  "customer-data-properties": "static-1.52280",
  "external-options-client-types": "static-1.4269",
  "framework-data-schema-resolvers": "static-1.7099",
  "property-value-citations": "static-1.2894",
  "reference-resolvers-lite": "static-1.8302",
  "hubspotter-http-shared-msw-handlers": "static-1.10448",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "cms-field-types": "static-1.5021",
  "content-icons-ui": "static-1.2289",
  "onboarding-journeys-lib": "static-1.633",
  "conversations-skeleton-state": "static-1.7453",
  "crm-message-bus": "static-1.43550",
  "customer-data-filters-ui-msw-helpers": "static-1.23010",
  "events-data-lib": "static-1.443",
  "FormUrlGenerator": "static-2.4929",
  "framework-builder-read-service-client": "static-1.4149",
  "framework-data-schema-quick-fetch": "static-1.7004",
  "multi-account-reference-resolvers": "static-1.1187",
  "onboarding-tours": "static-1.16976",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14260",
  "academy-common-lib": "static-1.14568",
  "pulse": "static-1.822",
  "dashboard-lib": "static-1.82342",
  "getting-started-shared-tasks": "static-1.19003",
  "hubspot-prosemirror-plugins": "static-1.18800",
  "share-with-third-party-component-lib": "static-1.8908",
  "ui-asset-management-lib": "static-1.11291",
  "user-context": "static-1.5317",
  "reporting-plugins": "static-1.10653",
  "reporting-reports": "static-1.68051",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.927",
  "nest": "static-1.441",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.103",
  "framework-listing-lib": "static-2.29273",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31176",
  "apps-service-types": "static-1.3973",
  "oauth-service-types": "static-1.4458",
  "onboarding-scopes": "static-1.6663",
  "purchase-motions-api": "static-1.6222",
  "signup-constants": "static-1.19381",
  "signup-ui-url-generator": "static-2.8263",
  "onboarding-tours-client": "static-1.5190",
  "platform-infra-nav-components": "static-1.7814",
  "subscription-experience-data-types": "static-1.15157",
  "crm-record-cards-service-types": "static-1.3727",
  "location-customization-utils-lib": "static-1.9877",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29120",
  "content-media-composition-data-lib": "static-1.12972",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4630",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.470",
  "ui-addon-opt": "static-4.8565",
  "commerce-tours-lib": "static-1.6472",
  "growth-onboarding-reliability": "static-1.5288",
  "sales-checkout-service-client": "static-1.3743",
  "data-token-picker": "static-1.16758",
  "FileManagerLib": "static-1.39865",
  "content-media-compositions": "static-2.16979",
  "media-bridge-lib": "static-1.19274",
  "card-properties-lib": "static-1.44803",
  "commerce-subscription-lib": "static-1.37601",
  "crm-actions": "static-1.6556",
  "crm-cards-sdk": "static-1.44231",
  "customer-data-properties-shared-msw-handlers": "static-1.9777",
  "customer-data-tracking": "static-1.7090",
  "hs-resources": "static-1.384",
  "calling-global-api": "static-1.65197",
  "calling-internal-common": "static-1.31520",
  "calling-lifecycle-internal": "static-1.66579",
  "calling-lifecycle-messages": "static-1.58873",
  "commerce-products-lib": "static-1.10285",
  "conditional-properties-service-client": "static-1.3940",
  "crm-links": "static-1.6522",
  "crm-index-visualization-core": "static-1.4407",
  "crm-pipelines-api-client-types": "static-1.4280",
  "formula-editor": "static-1.14610",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4359",
  "meetings-icalendar-utils-lib": "static-1.837",
  "multi-currency-client-types": "static-1.3834",
  "object-builder-ui-client": "static-1.49404",
  "pipeline-validation-client-types": "static-1.4109",
  "smart-property-lib": "static-1.8098",
  "tiered-pricing": "static-1.1777",
  "topics-actions-lib": "static-1.361",
  "ui-addon-form-validation": "static-1.11194",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.218",
  "restore-request-side-panel-lib": "static-1.1414",
  "growth-data-modal": "static-1.5756",
  "growth-onboarding-confetti": "static-1.3266",
  "growth-onboarding-next-action-utils": "static-1.2501",
  "onboarding-tours-utils": "static-1.1042",
  "ui-shepherd-tracker": "static-1.7848",
  "academy-service-client": "static-1.3892",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39724",
  "SafeStorage": "static-1.4610",
  "video-embed": "static-1.36420",
  "bend-plugin-pulse": "static-1.325",
  "event-emitter": "static-1.1156",
  "fast-json-patch": "static-1.66",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24834",
  "viral-links-lib": "static-1.7276",
  "nested-table": "static-1.443",
  "timezone-utils": "static-2.5449",
  "getting-started-shared-tasks-store": "static-1.18121",
  "campaign-roi-lib": "static-1.9842",
  "ui-addon-calendars": "static-2.5529",
  "customer-data-views-management": "static-1.25856",
  "framework-data-table": "static-2.12366",
  "marketing-platform-lib": "static-1.7073",
  "nudge-client-utils": "static-1.2998",
  "nudge-custom-ui-functions": "static-1.1359",
  "switchboard-lib": "static-1.425",
  "app-users-service-client": "static-1.5824",
  "app-users-service-types": "static-1.5232",
  "mini-checkout-client": "static-1.27347",
  "onboarding-utils": "static-1.5567",
  "permissions-shared-i18n-strings-fe": "static-1.2097",
  "ui-coaching-tips-shared-config": "static-1.29105",
  "edison-service-client-types": "static-1.592",
  "growth-onboarding-feedback-components": "static-1.6787",
  "audio-components": "static-1.6214",
  "FileManagerImages": "static-1.37376",
  "video-components": "static-1.13930",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92615",
  "customer-data-sidebar": "static-2.46559",
  "enrichment-properties-lib": "static-1.17535",
  "ui-addon-draggable-compat": "static-2.4464",
  "universal-record-utils-lib": "static-1.1558",
  "commerce-billing-lib": "static-1.19783",
  "commerce-shared-components-lib": "static-1.19041",
  "commerce-tools-ui-lib": "static-1.10878",
  "crm-fe-perf": "static-1.23107",
  "calling-error-reporting": "static-1.31527",
  "shared-worker-versioning": "static-1.11243",
  "calling-usage-tracker": "static-1.6746",
  "voice-sms-access-library": "static-1.1726",
  "commerce-permissions": "static-1.982",
  "products-iframe-lib": "static-1.8410",
  "products-ui-components-shared-msw-handlers": "static-1.10832",
  "crm-index-associations-lib": "static-1.6647",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10533",
  "sales-views-client-types": "static-1.4462",
  "bark-lib": "static-1.16702",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.510",
  "policy-lib": "static-1.6993",
  "react-tinymce": "static-1.55780",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10596",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54906",
  "tinymce-plugins": "static-1.58020",
  "tinymce-themes": "static-1.56876",
  "onboarding-data-sync-lib": "static-1.2317",
  "growth-onboarding-next-action-components": "static-1.2529",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4738",
  "outpost": "static-1.4371",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22024",
  "sales-email-signature-service-client": "static-1.4049",
  "ts-utils-lib": "static-1.379",
  "crm-export-dialog": "static-1.6489",
  "crm-view-components": "static-1.889",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7537",
  "nudge-custom-function-registry": "static-1.2755",
  "nudge-renderer-utils": "static-1.3074",
  "whisper-core-api": "static-1.7124",
  "InboxConnectUtils": "static-4.15360",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.6058",
  "settings-content-modals": "static-1.46651",
  "social-insights-client-types": "static-1.22597",
  "crm_universal": "static-1.22364",
  "customer-data-email": "static-1.18394",
  "card-payment-highlight-lib": "static-1.37770",
  "card-subscription-highlight-lib": "static-1.40024",
  "commerce-contract-lib": "static-1.12991",
  "invoices-highlight-card-lib": "static-1.55394",
  "orders-highlight-card-lib": "static-1.22003",
  "products-highlight-card-lib": "static-1.18568",
  "quotes-highlight-card-lib": "static-1.72640",
  "crm-source-interpretation-lib": "static-1.5539",
  "crm-object-search-query-utilities": "static-1.10024",
  "utility-belt": "static-1.2737",
  "payments-enrollment-embed-lib": "static-1.23600",
  "stripe-embedded-components": "static-1.7863",
  "customer-data-rte": "static-1.33483",
  "cv-backend-services": "static-1.1589",
  "growth-onboarding-empty-states": "static-1.6127",
  "payments-post-enroll-local-storage-lib": "static-1.5310",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38730",
  "calling-orchestration-schema": "static-1.36503",
  "react-reducer-toolkit": "static-1.16159",
  "hub-http-contrib": "static-1.3246",
  "interframe": "static-3.4961",
  "tinymce-data": "static-1.40991",
  "ui-addon-sales-email": "static-1.5417",
  "layout-dnd-components": "static-1.12827",
  "layout-dnd-utils": "static-1.11802",
  "ui-brand-identity-lib": "static-1.16026",
  "NamespacedHubStyle": "static-2.9193",
  "meetings-connect-utils-lib": "static-1.7811",
  "checkout-sdk": "static-3.24190",
  "company-details-components": "static-1.6404",
  "payment-method-components": "static-1.7054",
  "pricing-pages-ui-components": "static-1.15128",
  "quote-checkout-service-types": "static-1.3658",
  "upgrade-catalog-service-types": "static-1.3695",
  "access-control-lib": "static-1.10643",
  "EmailComponents": "static-1.55359",
  "EmailData": "static-1.54037",
  "redux-less": "static-2.9686",
  "sequences-lib": "static-1.8391",
  "ui-gdpr-components": "static-1.10556",
  "products-ui-components": "static-1.40803",
  "accounting-integrations-ui-components": "static-1.7402",
  "invoices-ui-lib": "static-1.55410",
  "commerce-products-api": "static-1.2588",
  "invoices-iframe-lib": "static-1.57468",
  "quotes-modal-lib": "static-1.103318",
  "quotes-ui-lib": "static-1.81361",
  "stripe-connect-js": "static-1.73",
  "draft-content-plugins": "static-1.28750",
  "ContentData": "static-1.69027",
  "layout-data-lib": "static-1.10127",
  "hub-http-rxjs": "static-1.823",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4142",
  "billing-payments-client-types": "static-1.4194",
  "react-performance-metrics-lib": "static-1.760",
  "pricing-pages-api": "static-1.14993",
  "ContentComponents": "static-2.71908",
  "marketing-contacts-lib": "static-1.10758",
  "marketing-email-service-types": "static-1.2046",
  "messaging-editing-lib": "static-1.46931",
  "messaging-usage-based-billing-components-lib": "static-1.1793",
  "automation-ui-source-apps": "static-1.19470",
  "automation-ui-types": "static-1.20388",
  "messaging-types-lib": "static-1.46668",
  "onboarding-settings-client": "static-1.4712",
  "sequences-client-types-lib": "static-1.8248",
  "commerce-tax-lib": "static-1.743",
  "price-books-api": "static-1.1511",
  "price-books-components": "static-1.1569",
  "property-description-translator": "static-1.4044",
  "ramp-editor": "static-1.711",
  "commerce-analytics-service-client": "static-1.3731",
  "totals-ui-components": "static-1.24124",
  "SalesContentIndexUI": "static-3.9514",
  "advanced-menus-core": "static-1.15453",
  "advanced-menus-lib": "static-1.12345",
  "ui-memberships-settings-lib": "static-1.34612",
  "segments-query-core": "static-1.1627",
  "trials-service-types": "static-1.4090",
  "automation-ui-ubb": "static-1.6304",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7543",
  "data-token-views": "static-1.16739",
  "forms-utils-lib": "static-1.12948",
  "payments-embed-points-lib": "static-1.13440",
  "simple-menus-core": "static-1.15452",
  "simple-menus-lib": "static-1.16969",
  "videoconference-integration-components": "static-1.7116",
  "marketing-contacts-client": "static-1.7715",
  "mc-hard-limits-client-types": "static-1.107",
  "automation-applications-service-types": "static-1.3629",
  "automation-platform-service-types": "static-1.2640",
  "ContentEditorUI": "static-2.77687",
  "short-messages-app-service-client": "static-1.4123",
  "web-interactives-components": "static-1.14108",
  "web-interactives-data": "static-1.14109",
  "messaging-shared-utils-lib": "static-1.1242",
  "messaging-user-info-utils-lib": "static-1.1412",
  "email-portal-health-service-types": "static-1.1182",
  "line-items-api": "static-1.985",
  "commerce-totals-service-types": "static-1.3958",
  "FireAlarmUi": "static-1.4651",
  "sales-templates-service-types-lib": "static-1.4311",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22324",
  "automation-ui-usage-tracking": "static-1.21787",
  "data-studio-ubb": "static-1.3304",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27483",
  "collaboration-sidebar": "static-1.58495",
  "content-management-data-lib": "static-1.5799",
  "copilot-plugins": "static-1.11626",
  "cta-picker": "static-1.36908",
  "customer-agent-discovery-components-lib": "static-1.3669",
  "editor-components": "static-1.13524",
  "editor-iframe-lib": "static-1.8677",
  "error-messaging-js": "static-1.5400",
  "FormsCommonComponents": "static-1.86389",
  "pictos": "static-7.188",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10851",
  "SharedLegalStrings": "static-1.1950",
  "smart-content-core": "static-1.42988",
  "smart-content-lib": "static-1.43641",
  "social-composer-lib": "static-1.59911",
  "structured-content-lib": "static-1.25730",
  "theme-previewer-lib": "static-1.53758",
  "tinymce-copilot": "static-1.16974",
  "xray-recommendation-lib": "static-1.8159",
  "automation-ui-routing": "static-1.21745",
  "sql-reporting-client-types": "static-1.5811",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42627",
  "campaigns-utils-lib": "static-1.3399",
  "reporting-enablement": "static-1.23590",
  "chatspot-widget-iframe": "static-1.22341",
  "collaboration-sidebar-common": "static-1.3292",
  "forms-ai-lib": "static-1.4626",
  "codemirror-dlb": "static-1.59246",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6641",
  "report-customization-components": "static-1.13694",
  "data-quality-ui-library": "static-1.13571",
  "reporting-filters": "static-1.822",
  "reporting-insights-lib": "static-1.2351"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12997",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9862",
  "foundations-components": "/foundations-components/static-1.8314",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1339",
  "foundations-theming": "/foundations-theming/static-1.4649",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8229",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10450",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11679",
  "I18n": "/I18n/static-7.1650",
  "jasmine-runner": "/jasmine-runner/static-1.6660",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.461",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13060",
  "quartz": "/quartz/static-1.7303",
  "react-dlb": "/react-dlb/static-1.83",
  "react-rhumb": "/react-rhumb/static-1.16910",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3061",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10306",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12725",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7491",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11352",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9739",
  "unified-auth": "/unified-auth/static-1.738",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1020",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.6",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8301",
  "hub-http": "/hub-http/static-1.6422",
  "integrations-lib": "/integrations-lib/static-1.16793",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20421",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.407",
  "property-management-iframe": "/property-management-iframe/static-1.13833",
  "quartz-config": "/quartz-config/static-1.1081",
  "quartz-core": "/quartz-core/static-1.6522",
  "quartz-routing": "/quartz-routing/static-1.733",
  "quick-fetch": "/quick-fetch/static-1.4060",
  "react": "/react/static-7.189",
  "rpc-client-utils": "/rpc-client-utils/static-1.4864",
  "ts-schema": "/ts-schema/static-1.4223",
  "ui-universal-auth": "/ui-universal-auth/static-1.9224",
  "UIComponents": "/UIComponents/static-3.8625",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3542",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3580",
  "quartz-webpack": "/quartz-webpack/static-1.3527",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.381",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4583",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5081",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2365",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9631",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5484",
  "react-virtualized": "/react-virtualized/static-2.102",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2346",
  "ui-fonts": "/ui-fonts/static-1.941",
  "ui-images": "/ui-images/static-2.1213",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3132",
  "foundations-theming-base": "/foundations-theming-base/static-1.3634",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.781",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3340",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4529",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8912",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9468",
  "ai-rendering-library": "/ai-rendering-library/static-1.10892",
  "chirp-fetch": "/chirp-fetch/static-1.2093",
  "connections-embed-lib": "/connections-embed-lib/static-1.1361",
  "copilot-toolkit": "/copilot-toolkit/static-1.11654",
  "feedback-loader": "/feedback-loader/static-1.29667",
  "laboratory-lib": "/laboratory-lib/static-3.7357",
  "marketplace-embed": "/marketplace-embed/static-1.22700",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10316",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20376",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14591",
  "sanitize-text": "/sanitize-text/static-1.8351",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.6",
  "wootric-nps": "/wootric-nps/static-1.7125",
  "quartz-head": "/quartz-head/static-1.968",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4859",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4353",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2629",
  "reporting-data": "/reporting-data/static-1.68373",
  "cssUtils": "/cssUtils/static-1.852",
  "flux-actions": "/flux-actions/static-1.355",
  "HubStyle": "/HubStyle/static-2.11986",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10414",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10571",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.6",
  "icons": "/icons/static-2.668",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18953",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4713",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5797",
  "quartz-i18n": "/quartz-i18n/static-1.978",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.255",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.778",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.832",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.942",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.276",
  "slack-ui-library": "/slack-ui-library/static-1.10605",
  "fsm": "/fsm/static-1.3937",
  "customer-data-objects": "/customer-data-objects/static-1.7887",
  "property-translator": "/property-translator/static-1.5600",
  "hs-locale-management": "/hs-locale-management/static-1.223",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8132",
  "hs-promise-utils": "/hs-promise-utils/static-1.5799",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5083",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14208",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5813",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7983",
  "sanitize": "/sanitize/static-1.4683",
  "superstore": "/superstore/static-1.4964",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10467",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8195",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "hubspotter-http": "/hubspotter-http/static-1.4793",
  "immutable-less": "/immutable-less/static-1.4856",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17828",
  "nav-meta": "/nav-meta/static-1.30239",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18265",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.789",
  "ai-studio-lib": "/ai-studio-lib/static-1.12236",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18808",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.334",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9280",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8228",
  "ui-product-approvals": "/ui-product-approvals/static-1.28894",
  "ui-tool-access": "/ui-tool-access/static-1.10358",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3987",
  "property-management-common": "/property-management-common/static-1.6121",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.978",
  "quartz-test": "/quartz-test/static-1.978",
  "quartz-tracking": "/quartz-tracking/static-1.682",
  "trellis-components": "/trellis-components/static-1.2365",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.274",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-public": "/usage-tracker-public/static-1-session-replay-endpoint-migration.6",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22350",
  "ContentUtils": "/ContentUtils/static-1.68952",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13237",
  "sassPrefix": "/sassPrefix/static-1.160",
  "avatar-components": "/avatar-components/static-1.2702",
  "breeze-engine-core": "/breeze-engine-core/static-1.709",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.516",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40575",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13382",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15108",
  "ExportDialog": "/ExportDialog/static-6.10584",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41813",
  "reporting-snowflake": "/reporting-snowflake/static-1.56991",
  "reporting-ui-components": "/reporting-ui-components/static-2.65644",
  "reporting-visualizations": "/reporting-visualizations/static-1.60449",
  "trellis-theming": "/trellis-theming/static-1.1158",
  "ui-addon-teams": "/ui-addon-teams/static-1.21807",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.406",
  "magpie-lib": "/magpie-lib/static-1.5697",
  "navigation-components": "/navigation-components/static-1.18602",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1431",
  "magpie-types": "/magpie-types/static-1.5157",
  "simple-logging-lib": "/simple-logging-lib/static-1.3255",
  "fail-safe": "/fail-safe/static-1.152",
  "app-governance-lib": "/app-governance-lib/static-1.2172",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10707",
  "purchase-motions-components": "/purchase-motions-components/static-1.6219",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9837",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3907",
  "reference-resolvers": "/reference-resolvers/static-1.8381",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4128",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.542",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3216",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3348",
  "atom": "/atom/static-1.5281",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "salesImages": "/salesImages/static-1.529",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10846",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4960",
  "content-assistance-lib": "/content-assistance-lib/static-1.8064",
  "content-media-capture": "/content-media-capture/static-1.5168",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10030",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24225",
  "growth-payments-core": "/growth-payments-core/static-1.25969",
  "knowledge-content-types": "/knowledge-content-types/static-1.8597",
  "payment-link-components": "/payment-link-components/static-1.23982",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20176",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10091",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9286",
  "video-components-external": "/video-components-external/static-1.11928",
  "video-data-lib": "/video-data-lib/static-1.35586",
  "navigation-messaging": "/navigation-messaging/static-1.7929",
  "react-dnd-compat": "/react-dnd-compat/static-1.4820",
  "batch-promise": "/batch-promise/static-1.1750",
  "crm-component-utils": "/crm-component-utils/static-1.39633",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6093",
  "customer-data-properties": "/customer-data-properties/static-1.52280",
  "external-options-client-types": "/external-options-client-types/static-1.4269",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7099",
  "property-value-citations": "/property-value-citations/static-1.2894",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8302",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10448",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "cms-field-types": "/cms-field-types/static-1.5021",
  "content-icons-ui": "/content-icons-ui/static-1.2289",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.633",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7453",
  "crm-message-bus": "/crm-message-bus/static-1.43550",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23010",
  "events-data-lib": "/events-data-lib/static-1.443",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4929",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4149",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7004",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1187",
  "onboarding-tours": "/onboarding-tours/static-1.16976",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14260",
  "academy-common-lib": "/academy-common-lib/static-1.14568",
  "pulse": "/pulse/static-1.822",
  "dashboard-lib": "/dashboard-lib/static-1.82342",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19003",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18800",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8908",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11291",
  "user-context": "/user-context/static-1.5317",
  "reporting-plugins": "/reporting-plugins/static-1.10653",
  "reporting-reports": "/reporting-reports/static-1.68051",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.927",
  "nest": "/nest/static-1.441",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.103",
  "framework-listing-lib": "/framework-listing-lib/static-2.29273",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31176",
  "apps-service-types": "/apps-service-types/static-1.3973",
  "oauth-service-types": "/oauth-service-types/static-1.4458",
  "onboarding-scopes": "/onboarding-scopes/static-1.6663",
  "purchase-motions-api": "/purchase-motions-api/static-1.6222",
  "signup-constants": "/signup-constants/static-1.19381",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8263",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5190",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7814",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15157",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3727",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9877",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29120",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12972",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4630",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.470",
  "ui-addon-opt": "/ui-addon-opt/static-4.8565",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6472",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5288",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "data-token-picker": "/data-token-picker/static-1.16758",
  "FileManagerLib": "/FileManagerLib/static-1.39865",
  "content-media-compositions": "/content-media-compositions/static-2.16979",
  "media-bridge-lib": "/media-bridge-lib/static-1.19274",
  "card-properties-lib": "/card-properties-lib/static-1.44803",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37601",
  "crm-actions": "/crm-actions/static-1.6556",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44231",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9777",
  "customer-data-tracking": "/customer-data-tracking/static-1.7090",
  "hs-resources": "/hs-resources/static-1.384",
  "calling-global-api": "/calling-global-api/static-1.65197",
  "calling-internal-common": "/calling-internal-common/static-1.31520",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66579",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58873",
  "commerce-products-lib": "/commerce-products-lib/static-1.10285",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3940",
  "crm-links": "/crm-links/static-1.6522",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4407",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4280",
  "formula-editor": "/formula-editor/static-1.14610",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4359",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.837",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3834",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49404",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4109",
  "smart-property-lib": "/smart-property-lib/static-1.8098",
  "tiered-pricing": "/tiered-pricing/static-1.1777",
  "topics-actions-lib": "/topics-actions-lib/static-1.361",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11194",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.218",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1414",
  "growth-data-modal": "/growth-data-modal/static-1.5756",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3266",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2501",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1042",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7848",
  "academy-service-client": "/academy-service-client/static-1.3892",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39724",
  "SafeStorage": "/SafeStorage/static-1.4610",
  "video-embed": "/video-embed/static-1.36420",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.325",
  "event-emitter": "/event-emitter/static-1.1156",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24834",
  "viral-links-lib": "/viral-links-lib/static-1.7276",
  "nested-table": "/nested-table/static-1.443",
  "timezone-utils": "/timezone-utils/static-2.5449",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18121",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9842",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5529",
  "customer-data-views-management": "/customer-data-views-management/static-1.25856",
  "framework-data-table": "/framework-data-table/static-2.12366",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7073",
  "nudge-client-utils": "/nudge-client-utils/static-1.2998",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1359",
  "switchboard-lib": "/switchboard-lib/static-1.425",
  "app-users-service-client": "/app-users-service-client/static-1.5824",
  "app-users-service-types": "/app-users-service-types/static-1.5232",
  "mini-checkout-client": "/mini-checkout-client/static-1.27347",
  "onboarding-utils": "/onboarding-utils/static-1.5567",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2097",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29105",
  "edison-service-client-types": "/edison-service-client-types/static-1.592",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6787",
  "audio-components": "/audio-components/static-1.6214",
  "FileManagerImages": "/FileManagerImages/static-1.37376",
  "video-components": "/video-components/static-1.13930",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92615",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46559",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17535",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4464",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1558",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19783",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19041",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10878",
  "crm-fe-perf": "/crm-fe-perf/static-1.23107",
  "calling-error-reporting": "/calling-error-reporting/static-1.31527",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11243",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6746",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1726",
  "commerce-permissions": "/commerce-permissions/static-1.982",
  "products-iframe-lib": "/products-iframe-lib/static-1.8410",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10832",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6647",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10533",
  "sales-views-client-types": "/sales-views-client-types/static-1.4462",
  "bark-lib": "/bark-lib/static-1.16702",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.510",
  "policy-lib": "/policy-lib/static-1.6993",
  "react-tinymce": "/react-tinymce/static-1.55780",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10596",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54906",
  "tinymce-plugins": "/tinymce-plugins/static-1.58020",
  "tinymce-themes": "/tinymce-themes/static-1.56876",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2317",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2529",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4738",
  "outpost": "/outpost/static-1.4371",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22024",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4049",
  "ts-utils-lib": "/ts-utils-lib/static-1.379",
  "crm-export-dialog": "/crm-export-dialog/static-1.6489",
  "crm-view-components": "/crm-view-components/static-1.889",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7537",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2755",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3074",
  "whisper-core-api": "/whisper-core-api/static-1.7124",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15360",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.6058",
  "settings-content-modals": "/settings-content-modals/static-1.46651",
  "social-insights-client-types": "/social-insights-client-types/static-1.22597",
  "crm_universal": "/crm_universal/static-1.22364",
  "customer-data-email": "/customer-data-email/static-1.18394",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37770",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40024",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12991",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55394",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22003",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18568",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72640",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5539",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10024",
  "utility-belt": "/utility-belt/static-1.2737",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23600",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7863",
  "customer-data-rte": "/customer-data-rte/static-1.33483",
  "cv-backend-services": "/cv-backend-services/static-1.1589",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6127",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5310",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38730",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36503",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16159",
  "hub-http-contrib": "/hub-http-contrib/static-1.3246",
  "interframe": "/interframe/static-3.4961",
  "tinymce-data": "/tinymce-data/static-1.40991",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5417",
  "layout-dnd-components": "/layout-dnd-components/static-1.12827",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11802",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16026",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9193",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7811",
  "checkout-sdk": "/checkout-sdk/static-3.24190",
  "company-details-components": "/company-details-components/static-1.6404",
  "payment-method-components": "/payment-method-components/static-1.7054",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15128",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3658",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3695",
  "access-control-lib": "/access-control-lib/static-1.10643",
  "EmailComponents": "/EmailComponents/static-1.55359",
  "EmailData": "/EmailData/static-1.54037",
  "redux-less": "/redux-less/static-2.9686",
  "sequences-lib": "/sequences-lib/static-1.8391",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10556",
  "products-ui-components": "/products-ui-components/static-1.40803",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7402",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55410",
  "commerce-products-api": "/commerce-products-api/static-1.2588",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57468",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103318",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81361",
  "stripe-connect-js": "/stripe-connect-js/static-1.73",
  "draft-content-plugins": "/draft-content-plugins/static-1.28750",
  "ContentData": "/ContentData/static-1.69027",
  "layout-data-lib": "/layout-data-lib/static-1.10127",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.823",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4142",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4194",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.760",
  "pricing-pages-api": "/pricing-pages-api/static-1.14993",
  "ContentComponents": "/ContentComponents/static-2.71908",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10758",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2046",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46931",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1793",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19470",
  "automation-ui-types": "/automation-ui-types/static-1.20388",
  "messaging-types-lib": "/messaging-types-lib/static-1.46668",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4712",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8248",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.743",
  "price-books-api": "/price-books-api/static-1.1511",
  "price-books-components": "/price-books-components/static-1.1569",
  "property-description-translator": "/property-description-translator/static-1.4044",
  "ramp-editor": "/ramp-editor/static-1.711",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3731",
  "totals-ui-components": "/totals-ui-components/static-1.24124",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9514",
  "advanced-menus-core": "/advanced-menus-core/static-1.15453",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12345",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34612",
  "segments-query-core": "/segments-query-core/static-1.1627",
  "trials-service-types": "/trials-service-types/static-1.4090",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6304",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7543",
  "data-token-views": "/data-token-views/static-1.16739",
  "forms-utils-lib": "/forms-utils-lib/static-1.12948",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13440",
  "simple-menus-core": "/simple-menus-core/static-1.15452",
  "simple-menus-lib": "/simple-menus-lib/static-1.16969",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7116",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7715",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.107",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3629",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2640",
  "ContentEditorUI": "/ContentEditorUI/static-2.77687",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4123",
  "web-interactives-components": "/web-interactives-components/static-1.14108",
  "web-interactives-data": "/web-interactives-data/static-1.14109",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1242",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1412",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1182",
  "line-items-api": "/line-items-api/static-1.985",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3958",
  "FireAlarmUi": "/FireAlarmUi/static-1.4651",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4311",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22324",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21787",
  "data-studio-ubb": "/data-studio-ubb/static-1.3304",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27483",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58495",
  "content-management-data-lib": "/content-management-data-lib/static-1.5799",
  "copilot-plugins": "/copilot-plugins/static-1.11626",
  "cta-picker": "/cta-picker/static-1.36908",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3669",
  "editor-components": "/editor-components/static-1.13524",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8677",
  "error-messaging-js": "/error-messaging-js/static-1.5400",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86389",
  "pictos": "/pictos/static-7.188",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10851",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1950",
  "smart-content-core": "/smart-content-core/static-1.42988",
  "smart-content-lib": "/smart-content-lib/static-1.43641",
  "social-composer-lib": "/social-composer-lib/static-1.59911",
  "structured-content-lib": "/structured-content-lib/static-1.25730",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53758",
  "tinymce-copilot": "/tinymce-copilot/static-1.16974",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8159",
  "automation-ui-routing": "/automation-ui-routing/static-1.21745",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5811",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42627",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3399",
  "reporting-enablement": "/reporting-enablement/static-1.23590",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22341",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3292",
  "forms-ai-lib": "/forms-ai-lib/static-1.4626",
  "codemirror-dlb": "/codemirror-dlb/static-1.59246",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6641",
  "report-customization-components": "/report-customization-components/static-1.13694",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13571",
  "reporting-filters": "/reporting-filters/static-1.822",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2351"
}
};
